module.exports = __webpack_public_path__ + "img/button_backtointro-Text.dc05140f.svg";